// services/chatbot.service.ts
import axios from 'axios';
import { APIResponse } from './types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class ChatbotService {
  private static instance: ChatbotService;
  private sessionId: string;

  private constructor() {
    this.sessionId = this.generateSessionId();
  }

  static getInstance(): ChatbotService {
    if (!ChatbotService.instance) {
      ChatbotService.instance = new ChatbotService();
    }
    return ChatbotService.instance;
  }

  private generateSessionId(): string {
    return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  async sendMessage(message: string): Promise<APIResponse> {
    try {
      const response = await axios.post<APIResponse>(`${API_BASE_URL}/chatbot/message`, {
        message,
        sessionId: this.sessionId,
        timestamp: new Date().toISOString(),
      });

      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }

  async getQuickReplies(): Promise<APIResponse> {
    try {
      const response = await axios.get<APIResponse>(`${API_BASE_URL}/chatbot/quick-replies`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quick replies:', error);
      throw error;
    }
  }

  async getSessionHistory(): Promise<APIResponse> {
    try {
      const response = await axios.get<APIResponse>(`${API_BASE_URL}/chatbot/session/${this.sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session history:', error);
      throw error;
    }
  }

  resetSession(): void {
    this.sessionId = this.generateSessionId();
  }
}

export default ChatbotService;
